import { MLSListing, getLotAreaInSqft } from '@aloft/toolkit-shared';

export const getLotAreaSqftString = (listingData: MLSListing): string | undefined =>
  getLotAreaInSqft(listingData)?.unitAmount.toLocaleString('en-US');
